export const FILTERS_GET_PARAM_KEY = "filters";
